<template>
  <modal :show="show" @close="close">

    <div class="modal-header text-center mt-4">
      <h3 class="text-sm lg:mx-4 md:text-2xl">Be Recognized for your heart</h3>
    </div>

    <div class="modal-body block lg:flex p-1 md:p-2">
      <div class="thumb lg:w-1/2 bg-white md:m-2">
        <img :src="thumb" alt="" class="hiddsen md:inline max-h-16" />
      </div>

      <div class="fields lg:w-1/2 block lg:flex flex-col flex-wrap justify-between m-2">
        <div class="mb-auto">
          <label
            class="form-label mb-2 lg:mb-4 block"
            :class="{
              hasError: isNameValid() === false,
              valid: isNameValid() === true,
            }"
          >
            <input
              type="text"
              v-model="name"
              class="form-control w-full h-8 lg:h-12 p-2 lg:p-6 rounded"
              placeholder="Name"
              @input="nameInit = true"
              maxlength="40"
            />
          </label>

          <label
            class="form-label mb-2 lg:mb-6 block"
            :class="{
              hasError: isEmailValid() === false,
              valid: isEmailValid() === true,
            }"
          >
            <input
              type="email"
              v-model="email"
              class="form-control w-full h-8 lg:h-12 p-2 lg:p-6 rounded"
              placeholder="Your Email"
            />
          </label>

          <label class="form-label">
            <CheckMark v-model="anon" class="h-12"
              >Don't show my name publicly
            </CheckMark>
          </label>
        </div>

        <div class="modal-footer mt-auto flex w-full">
          <Button
            id="submitHeart"
            class="h-10 bg-pink-100 text-red-100 border-red-100 border-2 rounded border-solid flex-grow float-right items-center justify-center rounded-8"
            @click="checkForm"
          >
            <span>Submit</span></Button
          >
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Button from "@/components/Button.vue";
import CheckMark from "@/components/CheckMark.vue";
import Axios from "axios";

export default {
  name: "SubmitModal",
  components: { Modal, CheckMark },
  props: ["show", "thumb"],
  data: function() {
    return {
      anon: false,
      // eslint-disable-next-line
      emailregex: new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      ),
      email: "",
      name: "",
      nameInit: false,
      submitted: false,
    };
  },
  methods: {
    close: function() {
      this.$emit("close");
      this.title = "";
      this.body = "";
    },
    submitHeart: function() {
      var o = {
          artist: this.name,
          email: this.email,
          anonymous: this.anon==true ? "1" : "0",
          imagedata: this.thumb,
      };
      console.log(o);
      Axios({
        method: "post",
        url: "https://api.caseyhouse.com/sendyourlove/custom/up",
        data: {
          artist: this.name,
          email: this.email,
          anonymous: this.anon==true ? "1" : "0",
          imagedata: this.thumb,
        },
      })
      .then(
        (response) => {
          console.log(response);
          this.close();
          this.submitted = true;
          alert(
            "Success. Your Image was uploaded. We will email you when it is published."
          );
        }
      )
      .catch(function (error) {
    if (error.response) {
 
      if(error.response.status == 409 ) alert("Uh oh. Looks like this image has already been uploaded");

    }
    });
    },
    isEmailValid: function() {
      return this.email == ""
        ? ""
        : this.emailregex.test(this.email)
        ? true
        : false;
    },
    isNameValid() {
      if (this.nameInit == false) {
        return "";
      }
      if (this.nameInit == true && this.name.length > 1) {
        return true;
      }
      return false;
    },
    checkForm(e) {
      if (this.isEmailValid() && this.isNameValid() && this.thumb.length > 0) {
        console.log("submitting");
        this.submitHeart();
      } else {
        alert("Please correct the errors");
      }
    },
  },
};
</script>

<style scoped>
input {
  padding: 0.5rem;
  color: #19324f;
}

label {
  position: relative;
}

label::after {
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  font-weight: bold;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
}

label.hasError::after {
  content: "!";
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
  background: #ff3c39;
  color: white;
  display: block;
}

label.valid::after {
  content: "\2713";
  display: block;
  color: lightseagreen;
}
</style>
